import { FC } from 'react';

import { TWITTER_OAUTH_URL } from '@/config';

import { Button, SvgIcon } from '@/components';

import styles from './Twitter.module.sass';

interface TwitterAuthProps {
  disabled?: boolean;
}

const TwitterAuth: FC<TwitterAuthProps> = (props) => {
  const { disabled = false } = props;

  const clickHandler = () => {
    window.location.href = TWITTER_OAUTH_URL;
  };

  return (
    <Button
      size="xl"
      type="shadow"
      corner="rect"
      className={styles.short}
      onClick={clickHandler}
      disabled={disabled}
    >
      <SvgIcon name="twitter" />
    </Button>
  );
};

export default TwitterAuth;
